import React from 'react';
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { Card, Container, Grid, TextField } from '@material-ui/core';
import { CustomizedTypography, CustomizedButton } from '@components/Customized';
import * as assets from '@assets';
import { MuiBox, useCardStyle } from './styled';
import { SignInForm } from './types';
import { emailRegex } from '@utils/regex';

interface Props {
  onSubmit: (_: SignInForm) => void;
}

const RequestPasswordPresenter = ({ onSubmit }: Props) => {
  const { handleSubmit, errors, control } = useForm();
  const history = useHistory();
  const classes = useCardStyle();
  const emailError = errors && errors['email'] ? true : false;
  return (
    <MuiBox>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className={classes.logoRoot}
      >
        <img
          style={{ cursor: 'pointer' }}
          src={assets.LOGO_LARGE}
          width="125px"
          height="32px"
          alt=""
          onClick={() => history.push('/')}
        />
      </Grid>

      <Container
        maxWidth="xs"
        classes={{ maxWidthXs: classes.containerXs }}
        disableGutters={true}
      >
        <Card
          elevation={0}
          className={classes.root}
          component="form"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Grid
            container
            alignItems="center"
            justifyContent="center"
            direction="column"
          >
            <CustomizedTypography
              align="center"
              variant="h4"
              gutterBottoms={4}
              fontWeight={'500'}
            >
              비밀번호 재설정
            </CustomizedTypography>
            <CustomizedTypography
              align="center"
              variant="caption"
              gutterBottoms={32}
              fontWeight="300"
            >
              새 비밀번호를 설정할 수 있도록 이메일로 메시지가 전송됩니다.
            </CustomizedTypography>
          </Grid>

          <Grid
            container
            justifyContent="flex-start"
            direction="column"
            className={classes.textfieldGridContainer}
          >
            <CustomizedTypography
              variant="body1"
              color="textPrimary"
              fontWeight="normal"
              gutterBottoms={8}
            >
              이메일 *
            </CustomizedTypography>
            <Controller
              name="email"
              defaultValue=""
              control={control}
              rules={{
                required: true,
                pattern: {
                  value: emailRegex,
                  message: '올바른 이메일 형식으로 입력해주세요.'
                },
                maxLength: 60
              }}
              render={(renderProps) => {
                return (
                  <TextField
                    error={emailError}
                    InputProps={{
                      classes: {
                        notchedOutline: classes.notchedOutline,
                        input: classes.textfieldInputRoot
                      }
                    }}
                    placeholder="이메일"
                    variant="outlined"
                    size="small"
                    {...renderProps}
                  />
                );
              }}
            />
          </Grid>

          <CustomizedButton
            fullWidth
            type="submit"
            variant="contained"
            color="primary"
            disableElevation
            size="large"
          >
            임시 비밀번호 받기
          </CustomizedButton>
        </Card>
        <CustomizedButton
          fullWidth
          variant="text"
          color="default"
          style={{ marginTop: 18 }}
          onClick={() => {
            history.push('/login');
          }}
        >
          로그인으로 돌아가기
        </CustomizedButton>
      </Container>
    </MuiBox>
  );
};

export default RequestPasswordPresenter;
